module.exports = __webpack_public_path__ + "media/img/android-icon-36x36-911be06836666cc34919ecdeb38b2104.png";